import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import { SummaryPagePromotionsSectionComponent } from './summary-page-promotions-section.component';

@NgModule({
    imports: [CommonModule, RouterModule, TgGridModule, TgRackModule],
    declarations: [SummaryPagePromotionsSectionComponent],
    exports: [SummaryPagePromotionsSectionComponent]
})
export class SummaryPagePromotionsSectionModule {}
